import Vue from "vue";
import Router from "vue-router";
const Dashboard = () => import("@/views/Dashboard");
const Layout = () => import("@/views/Layout");
const AddWeight = () => import("@/views/AddWeight");
const Limits = () => import("@/views/Limits");
const WeightHistory = () => import("@/views/WeightHistory/WeightHistory");
const Calories = () => import("@/views/Calories");
const WithingsAuth = () => import("@/views/WithingsAuth");
const FitbitAuth = () => import("@/views/FitbitAuth");
const GoogleHealthAuth = () => import("@/views/GoogleHealthAuth");
const Sleep = () => import("@/views/Sleep");
const UserLogin = () => import("@/views/Login");

Vue.use(Router);

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/Dashboard",
      component: Layout,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "WithingsAuth",
          name: "WithingsAuth",
          component: WithingsAuth,
        },
        {
          path: "FitbitAuth",
          name: "FitbitAuth",
          component: FitbitAuth,
        },
        {
          path: "GoogleHealthAuth",
          name: "GoogleHealthAuth",
          component: GoogleHealthAuth,
        },
        {
          path: "add-weight",
          name: "AddWeight",
          component: AddWeight,
        },
        {
          path: "limits",
          name: "Limits",
          component: Limits,
        },
        {
          path: "weight-history",
          name: "WeightHistory",
          component: WeightHistory,
        },
        {
          path: "/calories",
          name: "Calories",
          component: Calories,
        },
        {
          path: "/sleep",
          name: "Sleep",
          component: Sleep,
        },
      ],
    },
    {
      path: "/user",
      name: "User",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "login/:nextUrl?",
          name: "UserLogin",
          component: UserLogin,
        },
      ],
    },
  ];
}
